import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function JoinInnerIcon(props: IconProps) {
    return <Icon {...props} iconKey={"join_inner"}/>
}
